<template>
  <div class="d-flex justify-space-between align-center mb-2">
    <a-space>
      <a-button type="danger" @click="add">
        <template #icon>
          <PlusOutlined />
        </template>
        新增团队
      </a-button>
      <a-button type="link" @click="getData">刷新数据</a-button>
    </a-space>
  </div>
  <a-table size="small" :columns="columns" bordered :data-source="data" :loading="dataLoading"
    :scroll="{ x: width, y: 600 }" :pagination="{
      current: page,
      pageSize: limit,
      total: count,
      showQuickJumper: true,
      showSizeChanger: true,
      showTotal: (total) => `共${total}条`,
    }" @change="(pagination) => {
      page = pagination.current;
      limit = pagination.pageSize;
    }">
    <template #bodyCell="{ record, column }">
      <template v-if="column.dataIndex === 'orgids'">
        <p v-for="orgid in record.orgids" :key="orgid">
          {{ getorgname(orgid) }}
        </p>
      </template>
      <template v-if="column.dataIndex === 'operation'">
        <a-space>
          <a href="javascript:;" @click="edit(record)">编辑</a>
          <a href="javascript:;" class="text-error" @click="showbind(record._id)">绑定商户</a>
        </a-space>
      </template>
    </template>
  </a-table>
  <a-modal v-model:visible="dataModal" :title="dataTitle" @ok="save" @cancel="cancelSave" ok-text="确认" cancel-text="取消"
    :confirm-loading="saving" :cancel-button-props="{ disabled: saving }" :maskClosable="false" :closable="!saving">
    <a-form ref="dataFormRef" name="dataForm" :model="dataForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"
      autocomplete="off">
      <a-row :gutter="16">
        <a-col :span="24">
          <a-form-item label="团队名称" name="name" :rules="[{ required: true, message: '请输入团队名称' }]">
            <a-input v-model:value="dataForm.name" placeholder="团队名称" :disabled="saving">
            </a-input>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
  <a-modal v-model:visible="bindModal" title="绑定商户" @ok="savebind" @cancel="cancelSaveBind" ok-text="确认"
    cancel-text="取消" :confirm-loading="saving" :cancel-button-props="{ disabled: saving }" :maskClosable="false"
    :closable="!saving">
    <a-table size="small" :columns="bindcolumns" bordered :data-source="bindorgs" :loading="dataLoading"
      :scroll="{ x: bindwidth, y: 600 }" :pagination="false">
      <template #title>
        <a-row :gutter="16">
          <a-col :span="18">
            <a-select v-model:value="bindorgid" :options="sorgs" :filter-option="$filters.filterOption" show-search
              placeholder="请选择" style="width:100%;">
            </a-select>
          </a-col>
          <a-col :span="6">
            <a-button type="link" @click="addbind" :disabled="!bindorgid">添加</a-button>
          </a-col>
        </a-row>
      </template>
      <template #bodyCell="{ record, column, index }">
        <template v-if="column.dataIndex === 'orgid'">
          {{ getorgname(record.orgid) }}
        </template>
        <template v-if="column.dataIndex === 'operation'">
          <a-popconfirm placement="left" title="移除绑定商户？" @confirm="delbind(index)">
            <a href="javascript:;" class="text-error"> 移除 </a>
          </a-popconfirm>
        </template>
      </template>
    </a-table>
  </a-modal>
</template>
<script setup>
import { PlusOutlined } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";
import { ref, watch, computed, onMounted, getCurrentInstance, } from "vue";
import _ from "underscore";
const columns = [
  { title: '团队名称', dataIndex: 'name', width: 150 },
  { title: '商户成员', dataIndex: 'orgids', width: 150 },
  { title: '创建时间', dataIndex: 'create_time', width: 150, },
  { title: '操作', dataIndex: 'operation', width: 100, fixed: 'right' }
];
const bindcolumns = [
  { title: '商户', dataIndex: 'orgid', width: 200 },
  { title: '操作', dataIndex: 'operation', width: 100, fixed: 'right' }
];

const { proxy } = getCurrentInstance();
const dataFormRef = ref();
const dataLoading = ref(false);
const page = ref(1);
const limit = ref(20);
const length = ref(0);
const count = ref(0);
const data = ref([]);
const dataForm = ref({});
const dataTitle = ref('');
const dataModal = ref(false);
const saving = ref(false);
const orgs = ref([]);
const bindorgs = ref([]);
const bindteamid = ref('');
const bindorgid = ref(null);
const bindModal = ref(false);

const width = computed(() => proxy.$utils.twidth(columns));
const bindwidth = computed(() => proxy.$utils.twidth(bindcolumns));

const sorgs = computed(() => orgs.value.map(n => ({ value: n._id, label: n.name })));

watch(() => page.value, () => {
  getData();
});
watch(() => limit.value, () => {
  if (page.value !== 1) page.value = 1;
  else getData();
});

onMounted(() => {
  getData();
});
const getData = () => {
  dataLoading.value = true;
  proxy.$api.doAPI("/orgteam/list", { page: page.value, limit: limit.value }).then((res) => {
    dataLoading.value = false;
    if (res.code === 0) {
      data.value = _.map(res.data.list, n => {
        return {
          ...n,
          create_time: proxy.$dateFormat(n.create_time, 'YYYY-MM-DD HH:mm'),
        }
      });
      length.value = res.data.length;
      count.value = res.data.count;
      if (length.value > 0 && page.value > length.value) page.value = 1;
      orgs.value = res.data.orgs;
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    dataLoading.value = false;
    console.error(err);
  });
};
const initForm = () => {
  return {
    _id: "",
    name: "",
  };
};
const add = () => {
  dataForm.value = initForm();
  dataTitle.value = '新增团队';
  dataModal.value = true;
};
const edit = (item) => {
  dataForm.value = _.pick(item, _.keys(initForm()));
  dataTitle.value = '编辑团队';
  dataModal.value = true;
}
const save = async () => {
  try {
    await dataFormRef.value.validateFields();
    saving.value = true;
    proxy.$api.doAPI("/orgteam/save", { dataForm: dataForm.value }).then((res) => {
      saving.value = false;
      if (res.code === 0) {
        dataModal.value = false;
        getData();
      } else {
        message.error(res.msg);
      }
    }).catch((err) => {
      saving.value = false;
      console.error(err);
    });
  } catch (errorInfo) {
    console.log("Failed:", errorInfo);
  }
};
const cancelSave = () => {
  dataFormRef.value.clearValidate();
  dataModal.value = false;
};
const showbind = (_id) => {
  dataLoading.value = true;
  proxy.$api.doAPI("/orgteam/showbindorgs", { _id }).then((res) => {
    dataLoading.value = false;
    if (res.code === 0) {
      bindteamid.value = _id;
      orgs.value = res.data.orgs;
      bindorgs.value = res.data.list;
      bindorgid.value = null;
      bindModal.value = true;
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    dataLoading.value = false;
    console.error(err);
  });
}
const addbind = () => {
  if (bindorgid.value) {
    let org = _.findWhere(orgs.value, { _id: bindorgid.value });
    if (org) {
      bindorgs.value = _.map(_.uniq([
        bindorgid.value,
        ..._.pluck(bindorgs.value, "orgid"),
      ]), n => ({ orgid: n }))
      message.success("已添加");
    }
    else {
      message.error("添加失败");
    }
  }
  bindorgid.value = null;
}
const delbind = (index) => {
  bindorgs.value.splice(index, 1);
}
const savebind = () => {
  saving.value = true;
  proxy.$api.doAPI("/orgteam/savebindorgs", { _id: bindteamid.value, orgs: bindorgs.value, }).then((res) => {
    saving.value = false;
    if (res.code === 0) {
      bindModal.value = false;
      getData();
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    saving.value = false;
    console.error(err);
  });
};
const cancelSaveBind = () => {
  bindModal.value = false;
};
const getorgname = (value) => {
  return _.findWhere(orgs.value, { _id: value })?.name;
}
</script>
<style lang="less" scoped>
:deep(.ant-layout-header) {
  display: flex;
  padding: 0 20px;
}

p {
  margin: 0;
  padding: 0;
}
</style>